import * as React from 'react';
import px from 'prop-types';
import { PureTip } from 'Common/components/ui';
import { Translation } from 'Common/components/localization';
import { useTranslation } from 'Common/hooks';

export default function BulkAddToCart({ 
    addToCartTip, 
    cartIsUpdating, 
    isLoading, 
    isMobile,
    onBulkAddToCart,
    selectedItems, 
}) {
    const addAllToCartLabel = useTranslation("Form.Button.AddAllToCart.Label");

    return (
        <div 
            className="ProductBuyInBulk__addAllToCart" 
            style={{
                position: 'sticky',
                top: isMobile ? '0px' : '90%',
                zIndex: 8,
                display: 'flex',
                justifyContent: 'center',
                marginBottom: isMobile ? '15px' : '0px',
                transition: 'all 0.2s ease-in-out'
            }}>
            
            <div style={{ position: 'relative', display: 'inline-block' }}>
                <button
                    disabled={
                        isLoading ||
                        cartIsUpdating ||
                        !selectedItems?.stats.hasValidItems ||
                        selectedItems?.stats.totalQuantity === 0
                    }
                    onClick={() => onBulkAddToCart(selectedItems)}
                    className="btn btn-primary shadow"
                    data-toggle="tooltip"
                    data-placement="left"
                    title={selectedItems?.stats.totalQuantity > 0 ? `Add ${selectedItems?.stats.totalQuantity} item${selectedItems.stats.totalQuantity > 1 ? 's' : ''} to cart` : 'Select quantities to add items'}
                >
                    <Translation id={addAllToCartLabel} />
                    <span className="badge badge-light ml-2">{selectedItems?.stats.totalQuantity}</span>
                </button>
                
                <div>
                    <PureTip
                        timestamp={addToCartTip?.timestamp}
                        placement="top" 
                        level={addToCartTip?.level}
                        hidden={addToCartTip?.hidden}
                        clickDismiss
                    >
                        <Translation id={addToCartTip?.message} params={addToCartTip?.params} />
                    </PureTip>
                </div>
            </div>
        </div>
    )
}

BulkAddToCart.propTypes = {
    addToCartTip: px.object, 
    cartIsUpdating: px.bool, 
    isLoading: px.bool, 
    isMobile: px.bool,
    onBulkAddToCart: px.func,
    selectedItems: px.object,
}